import type {
  AlertSettingKey,
  IAlertSettingRow,
  IAlertSettingsResponse,
  IAlertsHubUpdate,
} from '../../alert-kinds/index.js';

function applyRecipients(current: string[], { add = [], remove = [] }: NonNullable<IAlertsHubUpdate['recipients']>): string[] {
  const removed = new Set(remove);
  return [...current.filter((u) => !removed.has(u)), ...add.filter((u) => !current.includes(u))];
}

function patchRow(row: IAlertSettingRow, { channels, frequency, recipients }: IAlertsHubUpdate): IAlertSettingRow {
  return {
    ...row,
    channels: { ...row.channels, ...channels },
    ...(frequency && { frequency }),
    ...(recipients && { recipients: applyRecipients(row.recipients ?? [], recipients) }),
  };
}

/**
 * The settings as they will read once `update` is saved on the row `key` —
 * the optimistic picture a settings screen shows while the write is in
 * flight. The server's answer (a refetch) replaces it either way.
 */
export function applySettingUpdate(
  data: IAlertSettingsResponse,
  key: AlertSettingKey,
  update: IAlertsHubUpdate,
): IAlertSettingsResponse {
  return {
    // Whatever else the response carries (the Hub's `safetyEligible`) stands.
    ...data,
    groups: data.groups.map((group) => ({
      ...group,
      rows: group.rows.map((row) => (row.key === key ? patchRow(row, update) : row)),
    })),
  };
}
